<template>
  <HrmisCrudModule v-bind="config" />
</template>

<script>
import HrmisCrudModule from "./HrmisCrudModule.vue";

export default {
  name: "ModuleEducationHr",
  components: { HrmisCrudModule },
  data() {
    return {
      config: {
        title: "Education department HR",
        subtitle: "Deployments and school/unit assignments",
        icon: "🎓",
        listFunction: "getEducationDeploymentList",
        saveFunction: "saveEducationDeployment",
        permissionViewCodes: ["EDUCATION_HR_VIEW", "EDUCATION_HR_MANAGE"],
        permissionManageCodes: ["EDUCATION_HR_MANAGE"],
        loadEmployees: true,
        columns: [
          { key: "employee_name", label: "Employee" },
          { key: "school_unit", label: "School / unit" },
          { key: "deployment_type", label: "Type" },
          { key: "effective_date", label: "Effective" },
          { key: "status", label: "Status" }
        ],
        fields: [
          { key: "employee_id", label: "Employee", type: "employee", required: true, lockOnEdit: true },
          { key: "school_unit", label: "School / unit", type: "text" },
          { key: "deployment_type", label: "Deployment type", type: "text" },
          { key: "effective_date", label: "Effective date", type: "date" },
          { key: "notes", label: "Notes", type: "textarea" },
          {
            key: "status",
            label: "Status",
            type: "select",
            options: ["Active", "Ended"],
            default: "Active"
          }
        ]
      }
    };
  }
};
</script>
